import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { NetworkStatusService } from "./network-status.service";
import { Observable } from "rxjs";

@Injectable()
export class DataCleanupService extends HttpService {
  constructor(
    router: Router,
    cookieService: CookieService,
    private http: HttpClient,
    private networkStatusService: NetworkStatusService
  ) {
    super();
    super.setRouter(router);
    super.setHttpClient(http);
    super.setCookieService(cookieService);
  }

  deleteTenantData(): Observable<number> {
    if (this.networkStatusService.isOnline) {
      const endpoint = super.getEndpoint("tenantdata/delete");
      return this.http.delete<number>(endpoint);
    }
  }
}
